import * as React from "react";
import axios from "axios";

import Title from "../Layout/Title";

import { Button } from "@mui/material";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

export default function AddAccessKey({
  accessKeys,
  setAccessKeys,
  setOpen,
  refresh,
  setRefresh,
  setErr,
}) {
  const [keyName, setKeyName] = React.useState("");
  const [value, setValue] = React.useState("");
  const [description, setDescription] = React.useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    setOpen(false);
    setAccessKeys([
      { keyName: keyName, value: value, description: description },
      ...accessKeys,
    ]);
    setRefresh(refresh + 1);

    setKeyName("");
    setValue("");
    setDescription("");

    axios
      .post(`/addaccesskey`, {
        keyName: keyName,
        value: value,
        description: description,
      })
      .catch((err) => {
        setErr(err.response.data);
      });
  };

  return (
    <div>
      <Title>Create New Access Key</Title>
      <Box
        component="form"
        id="editForm"
        noValidate
        onSubmit={handleSubmit}
        sx={{
          mt: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <TextField
          autoFocus
          margin="normal"
          fullWidth
          id="KeyName"
          label="KeyName"
          name="KeyName"
          variant="standard"
          value={keyName}
          onChange={(e) => {
            setKeyName(e.target.value);
          }}
        />
        <TextField
          margin="normal"
          fullWidth
          id="Value"
          label="Value"
          name="Value"
          variant="standard"
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
          }}
        />
        <TextField
          margin="normal"
          fullWidth
          id="Description"
          label="Description"
          name="Description"
          variant="standard"
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />

        <Button
          disabled={!keyName || !value || !description}
          type="submit"
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
        >
          Add
        </Button>
        <Button type="reset" variant="contained" color="secondary">
                Reset
              </Button>
      </Box>
    </div>
  );
}
